export interface MenuSettings {
  menusList: [
    {
      id: Number;
      startTime: String;
      endTime: String;
      name: any;
      details: any;
      coverView: string;
    },
  ];

  pagination: {
    pageSize: number;
    currentPage: number;
  };

  total: number;
  showLoadMoreButton: boolean;
}
export default {
  pagination: {
    pageSize: 50,
    currentPage: 1,
  },
  showLoadMoreButton: true,

} as MenuSettings;

export const spaceName = 'caMenus';
